import {useContext} from 'react';
import {IAccountContext} from "../contexts/models/Account/IAccountContext.ts";
import {AccountContext} from "../contexts/Account/AccountContext.tsx";

export const useAccount = () => {
    return useContext<IAccountContext>(AccountContext);
}